import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, MailIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { COMPANY } from '../data/company';
/**
 * URL de retorno tras completar el pago. No recibe ni verifica información de
 * la pasarela, por lo que no muestra importes, referencias ni confirmaciones
 * técnicas de la operación.
 */
export function PaymentConfirmedPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] pt-20 sm:pt-24" data-id="element-396" data-mp="1el041z5yb4p3">
      <section className="section-shell" data-id="element-397" data-mp="1emktxbhblzgm">
        <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-398" data-mp="1sl11t5qx5w0c">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          ease: [0.23, 1, 0.32, 1]
        }} className="mx-auto max-w-3xl border border-white/10 px-6 py-10 sm:px-12 sm:py-14" data-id="element-399" data-mp="1nl6ch6mslehe">
            <span className="flex h-12 w-12 items-center justify-center border border-white/25 text-white" data-id="element-400" data-mp="2r2se0gsfwnbo">
              <CheckIcon size={22} aria-hidden="true" data-id="element-401" data-mp="2w24zoy7kroco" />
            </span>
            <p className="eyebrow mt-8" data-id="element-402" data-mp="311hpnrtqtbjh">Confirmación</p>
            <h1 className="mt-5 text-4xl font-medium tracking-[-0.055em] text-white sm:text-5xl" data-id="element-403" data-mp="310zii05jlcws">
              Pago completado
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-neutral-300 sm:text-lg" data-id="element-404" data-mp="28ckh4gfc2t3x">
              Gracias. Hemos recibido tu pago correctamente. El equipo de{' '}
              {COMPANY.legalName} continuará ahora con el proceso de
              incorporación y preparación de tu servicio.
            </p>
            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-405" data-mp="1ko181yogmcas">
              Recibirás las siguientes instrucciones a través de los datos de
              contacto facilitados.
            </p>

            <div className="mt-10 flex flex-col gap-3 border-t border-white/10 pt-8 sm:flex-row sm:items-center" data-id="element-406" data-mp="1hk23ycfy4g0b">
              <Link to="/" className="group inline-flex h-[52px] items-center justify-center gap-2 bg-white px-6 text-sm font-semibold text-black transition-colors hover:bg-neutral-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#0a0a0a] sm:min-w-[200px]" data-id="element-407" data-mp="1cma4mxcz1rm3">
                Volver a Growthly
                <ArrowRightIcon size={16} className="transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-408" data-mp="tq26semagj0t" />
              </Link>
              <a href={`mailto:${COMPANY.supportEmail}`} className="inline-flex h-[52px] items-center justify-center gap-2 border border-white/25 px-6 text-sm font-semibold text-white transition-colors hover:border-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#0a0a0a]" data-id="element-409" data-mp="2jzlwdu93ub4d">
                <MailIcon size={15} aria-hidden="true" data-id="element-410" data-mp="2dkdan4pdlv1h" />
                Contactar con soporte
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}